module.exports = __webpack_public_path__ + "static/cam-aleon-0a1dfc832af4c55054ae030764ff38a2.jpg";